/**
 * contains the abi and contract address
*/

class GuildsContract {
    constructor() {
        this.abi = [
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32[16]",
				"name": "sampleHashes",
				"type": "bytes32[16]"
			},
			{
				"internalType": "bytes32[16]",
				"name": "titles",
				"type": "bytes32[16]"
			},
			{
				"internalType": "bytes32[16]",
				"name": "youtubeVideoIds",
				"type": "bytes32[16]"
			},
			{
				"internalType": "bytes32[16]",
				"name": "coverArtHashes",
				"type": "bytes32[16]"
			},
			{
				"internalType": "uint256[16]",
				"name": "discogIds",
				"type": "uint256[16]"
			},
			{
				"internalType": "bytes32[4][16]",
				"name": "tagsToAdd",
				"type": "bytes32[4][16]"
			},
			{
				"internalType": "bytes32[4][16]",
				"name": "stylesToAdd",
				"type": "bytes32[4][16]"
			},
			{
				"internalType": "bytes32[16]",
				"name": "countries",
				"type": "bytes32[16]"
			},
			{
				"internalType": "int16[16]",
				"name": "sampleYears",
				"type": "int16[16]"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			},
			{
				"internalType": "bytes32[9]",
				"name": "encryptedContentKey",
				"type": "bytes32[9]"
			},
			{
				"internalType": "bytes32[6]",
				"name": "publicKey",
				"type": "bytes32[6]"
			}
		],
		"name": "newEncryptedSamples",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32[16]",
				"name": "sampleHashes",
				"type": "bytes32[16]"
			},
			{
				"internalType": "bytes32[16]",
				"name": "titles",
				"type": "bytes32[16]"
			},
			{
				"internalType": "bytes32[16]",
				"name": "youtubeVideoIds",
				"type": "bytes32[16]"
			},
			{
				"internalType": "bytes32[16]",
				"name": "coverArtHashes",
				"type": "bytes32[16]"
			},
			{
				"internalType": "uint256[16]",
				"name": "discogIds",
				"type": "uint256[16]"
			},
			{
				"internalType": "bytes32[4][16]",
				"name": "tagsToAdd",
				"type": "bytes32[4][16]"
			},
			{
				"internalType": "bytes32[4][16]",
				"name": "stylesToAdd",
				"type": "bytes32[4][16]"
			},
			{
				"internalType": "bytes32[16]",
				"name": "countries",
				"type": "bytes32[16]"
			},
			{
				"internalType": "int16[16]",
				"name": "sampleYears",
				"type": "int16[16]"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "newSamplesWithMetadata",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"internalType": "string",
				"name": "title",
				"type": "string"
			},
			{
				"internalType": "bytes32",
				"name": "youtubeVideoId",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32[4]",
				"name": "tagsToAdd",
				"type": "bytes32[4]"
			},
			{
				"internalType": "bytes32[4]",
				"name": "stylesToAdd",
				"type": "bytes32[4]"
			},
			{
				"internalType": "bytes32",
				"name": "country",
				"type": "bytes32"
			},
			{
				"internalType": "int16",
				"name": "year",
				"type": "int16"
			},
			{
				"internalType": "uint256",
				"name": "discogsId",
				"type": "uint256"
			},
			{
				"internalType": "bytes32",
				"name": "coverArtHash",
				"type": "bytes32"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "newSampleWithMetadata",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "country",
				"type": "bytes32"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "setSampleCountry",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32[4]",
				"name": "stylesToAdd",
				"type": "bytes32[4]"
			},
			{
				"internalType": "bytes32",
				"name": "country",
				"type": "bytes32"
			},
			{
				"internalType": "int16",
				"name": "year",
				"type": "int16"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "setSampleDiscogsMetadata",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "style",
				"type": "bytes32"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "setSampleStyle",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "tag",
				"type": "bytes32"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "setSampleTag",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32[4]",
				"name": "tagsToAdd",
				"type": "bytes32[4]"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "setSampleTags",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"internalType": "int16",
				"name": "year",
				"type": "int16"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "setSampleYear",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "youtubeVideoId",
				"type": "bytes32"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "setSampleYoutubeVideoId",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "guildsAddress",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "encryptionAddress",
				"type": "address"
			}
		],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "title",
				"type": "string"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "SampleCreated",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "youtubeVideoId",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "SampledYoutube",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "tag",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "SampleTagged",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "style",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "SampleStyle",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "int16",
				"name": "year",
				"type": "int16"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "SampleYear",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "country",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "SampleCountry",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "discogsId",
				"type": "uint256"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "coverArtHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "NewDiscogsSample",
		"type": "event"
	}
        ];

        this.contractAddress = '0xc77d4e72dF7D0Bf96488eF543253af537fEb8737';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default GuildsContract;
